/*
 * @Author: ZJJ
 * @Date: 2025-11-05 19:13:16
 * @LastEditTime: 2025-11-28 11:43:53
 * @FilePath: /boluo_website/src/api/public-axios.js
 * @Description:
 */
import axios from "axios";
import { generateNonce, generateSign } from "./request";
import Vue from "../main";

let serverType = process.env.VUE_APP_SERVER_TYPE;
// serverType = 2;
// console.log("serverType", serverType);

let userApiUrl;
let boluoUniUrl;

if (serverType == 1) {
  //线上 https://boluo.boluoapp.com

  userApiUrl = "https://wanos-common.wavworks.com/wanosuser";
  boluoUniUrl = "https://boluo.boluoapp.com/boluouni";
} else if (serverType == 2) {
  //测试test  https://boluoweb-test.wanos.vip

  userApiUrl = "https://wanos-common-test3.wanos.vip/wanosuser";
  boluoUniUrl = "https://boluo-test.wanos.vip/boluouni";
} else if (serverType == 3) {
  //开发dev https://boluoweb-dev.wanos.vip

  userApiUrl = "https://wanos-common-dev.wanos.vip/wanosuser";
  boluoUniUrl = "https://boluo-dev.wanos.vip/boluouni";
} else if (serverType == 5) {
  userApiUrl = "";
  boluoUniUrl = "";
}

// 配置不同的接口地址和请求头信息
const baseURLs = {
  user: {
    baseURL: userApiUrl,
    headers: {
      deviceId: "fingerPrint",
      originEnd: "boluoweb"
      // sign 将在请求拦截器中动态生成
    }
  },
  uni: {
    baseURL: boluoUniUrl,
    headers: {
      deviceId: "fingerPrint",
      originEnd: "boluoweb", //boluoapplet
      UserToken: "token"
      // sign 将在请求拦截器中动态生成
    }
  }
};

// 创建axios实例并添加拦截器
const instances = {};
// 遍历baseURLs对象，根据不同的key，创建不同的实例
for (const key in baseURLs) {
  if (baseURLs[key]) {
    const options = baseURLs[key];
    const instance = axios.create(options);
    instance.interceptors.request.use(
      config => {
        // 请求拦截器
        // 获取加密方式 空或1代表吉利老方式/ 2代表新加密方式

        // 1. 处理固定头部
        let headers = JSON.parse(JSON.stringify(options.headers));
        for (const key in headers) {
          // 尝试从localStorage获取值
          let value = localStorage.getItem(headers[key]);
          // 如果localStorage中有值且不为"undefined"，使用localStorage的值
          // 否则保持原值（这样固定值如"boluoweb"会被保留）
          if (value && value != "undefined") {
            headers[key] = value;
          }
          // 如果localStorage中没有值，headers[key]保持原值不变
        }

        // 2. 生成签名
        // 获取请求参数：GET 请求在 params，POST 请求在 data
        let params = {};
        if (config.method === "get" || config.method === "GET") {
          params = config.params || {};
          config.params = params; // 确保 params 存在
        } else {
          params = config.data || {};
          config.data = params; // 确保 data 存在
        }

        // 生成随机字符串
        const nonce = generateNonce(16);

        // 生成签名（generateSign 内部会将 nonceStr 添加到参数中）
        const sign = generateSign(params, nonce);

        // 3. 合并所有头部
        config.headers = {
          ...config.headers,
          ...headers,
          sign, // 动态生成的签名
          nonceStr: nonce
        };

        // 打印请求头信息
        // console.log("请求头信息:", {
        //   deviceId: config.headers.deviceId || config.headers.deviceid,
        //   originEnd: config.headers.originEnd || config.headers.originend,
        //   sign: config.headers.sign
        // });

        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      response => {
        //响应拦截器
        try {
          if (response && response.data) {
            if (Object.prototype.hasOwnProperty.call(response.data, "code")) {
              let code = response.data.code;
              // 20000 ⽤⼾Token已过期
              // 20001 ⽤⼾Token⽆效
              // 20002 ⽤⼾Token⽆效
              // 20003 ⽤⼾账号不存在
              // 20005 ⽤⼾Token不⼀致
              if (
                code == 20000 ||
                code == 20001 ||
                code == 20002 ||
                code == 20003 ||
                code == 20005
              ) {
                // console.log("操作无效，请登录后重试");
                Vue.$store.dispatch("triggerLogout");
                Vue.$message.error("操作无效，请登录后重试");
              }
            }
          }
        } catch (e) {
          // 忽略打印异常
        }
        return response.data;
      },
      error => {
        return Promise.reject(error);
      }
    );

    instance.myRequest = {
      get: function (url, params = null, config) {
        return instance
          .get(url, {
            params,
            ...config
          })
          .catch(error => {
            if (error.response.status !== 200) {
              //弹出error msg
            }
            return Promise.reject(error);
          });
      },
      post: function (url, params = null, config) {
        return instance.post(url, params, config).catch(error => {
          if (error.response.status !== 200) {
            //弹出error msg
          }
          return Promise.reject(error);
        });
      },
      delete: function (url, params = null, config) {
        return instance
          .delete(url, {
            params,
            ...config
          })
          .catch(error => {
            if (error.response.status !== 200) {
              //弹出error msg
            }
            return Promise.reject(error);
          });
      }
    };
    instances[key] = instance;
  }
}

export default instances;
